import { computed, defineComponent, onMounted, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useViewStore } from 'src/stores/view';
import helpStickyOptions from './helpStickyOptions.vue';
export default defineComponent({
    components: {
        helpStickyOptions
    },
    setup() {
        const vueRoute = useRoute();
        const viewStore = useViewStore();
        const showFAB = computed({
            get: () => viewStore.showFAB,
            set: (newValue) => {
                viewStore.toggleShowFAB(newValue);
            }
        });
        const permaFAB = computed(() => viewStore.permaFAB);
        // view
        const isMounted = ref(false);
        onMounted(() => {
            isMounted.value = true;
        });
        // toggle when to show help sticky
        watch(vueRoute, (newValue) => {
            // toggle page sticky to show for paths which the
            // user is likely to be searching for app
            if (/\/(search|listing|propert|calendar|contact|favourites|inbox|admin)/.test(newValue.path) || ([
                'User Dashboard',
                'Booking Confirmation',
                'Booking Success',
                'Edit Listings',
                'Create Listing',
                'Manage Listings'
            ].indexOf(newValue.name) > -1)) {
                showFAB.value = false;
            }
        }, { immediate: true });
        return {
            showFAB,
            permaFAB,
            isMounted
        };
    }
});
